import { render, staticRenderFns } from "./AddTeamLeagueScores.vue?vue&type=template&id=1c785479&scoped=true&"
import script from "./AddTeamLeagueScores.vue?vue&type=script&lang=js&"
export * from "./AddTeamLeagueScores.vue?vue&type=script&lang=js&"
import style0 from "./AddTeamLeagueScores.vue?vue&type=style&index=0&id=1c785479&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c785479",
  null
  
)

export default component.exports